export function isSampled(sampleRatePercent: number): boolean {
	return Math.random() < sampleRatePercent / 100;
}
